<template lang="pug">
 .ticket
    .ticket__code(v-if="item.qr || item.code")
      qrcode-vue(:value="item.qr || item.code" :size="70" level="H")
    .ticket__desc
      .desc_title
        .tit(v-if="item.name") {{item.name}}
      .desc_row
        .col(v-if="item.code")
          .key Код товара:
          .value {{item.code}}
        .col
          .key Место:
          .value {{item.institution.name}}
        .col
          .key Стоимость:
          .value {{item.priceStr}}
</template>

<script>
import QrcodeVue from 'qrcode.vue';
export default {
  props: ['item'],
  components: {
    QrcodeVue,
  },
};
</script>

<style lang="scss" scoped>

</style>
